import React from 'react';
import { Grid } from '@mui/material';

import AuthContainer from 'components/AuthContainer';
import TopSection from 'components/TopSection/TopSection';
import DataList from './components/DataList/DataList';
import StyledActivities from './Prompts.styles';

const Prompts: React.FC = () => {
  return (
    <AuthContainer>
      <TopSection title="Prompts manager" hideFilter />
      <StyledActivities>
        <Grid container spacing={2}>
            <DataList />
        </Grid>
      </StyledActivities>
    </AuthContainer>
  );
};

export default Prompts;
